<template>
  <div class="hello">
    <Header/>
	<h1>Over schisis</h1>
	<p v-html="body"></p>
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: 'About',
  components: { Header },
  data () {
    return {
      body: ''
    }
  },
  created: function(){
    this.$http.get('wp/v2/pages/892').then(response => {
    	var myReg = /\[.+\]/g;
     	this.body = response.body.content.rendered;
     	this.body = this.body.replace(myReg, '');
    }, error => {
      alert(error);
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/more_info/about.vue